module.exports = __webpack_public_path__ + "img/2-1.52623656.svg";